module.exports = __webpack_public_path__ + "bdf6ddc0e70e1f74e89576417ad92b97.pdf";